import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { UserBasicInfo } from "../model/user/UserBasicInfo";
import { environment } from '../../../environments/environment';
import { CareHomeDetail } from '../model/carehome';
import { HttpHelperService } from './httphelper.service';

export const API_URL = environment.apiUrl;

@Injectable()
export class AccountService {
    constructor(private http: HttpClient, private httpHelperService: HttpHelperService) {
    }

    getUserCareHomes(id?: string, username?: string) {
        return this.http.get<CareHomeDetail[]>(`${API_URL}account/usercarehomes?id=${id}&username=${username}`, this.httpHelperService.getHttpOptions());
    }
}